
<template>
    <div class="main" :class="{'main-hide-text': shrink}">
        <top-notification ref="topNotification" msg="您当前的浏览器版本过低，为了保证您能正常使用本系统的全部功能，推荐您下载最新版的360浏览器、Chrome浏览器或QQ浏览器"></top-notification>
        <div class="main-header-con" :style="{paddingLeft: '0'}">
            <div class="main-header" ref="mainHeader">
                <div class="header-logo" ref="headerLogo">
                    <a href="/index"><img src="../../assets/images/logo.png" key="max-logo" style="height: 42px" /></a>
                </div>
                <div class="home-con" ref="homeCon">
                    <a href="/index" style="color:#fff"><Icon type="ios-home" size="15"></Icon></a>
                </div>
                <div class="navicon-con" @click="toggleClick">
                    <a :style="{transform: 'rotateZ(' + (this.shrink ? '-90' : '0') + 'deg)'}" type="text">
                        <Icon type="md-menu" size="15"/>
                    </a>
                </div>
                <div class="header-avator">
                    <ul class="nav">
                        <template v-for="(menu, key) in menuArray">
                            <template v-if="!menu.hide">
                                <li v-if="menu.type == 'simple'" class="dropdown" :class="{'menu-active':routerName == menu.routerName}">
                                    <a @click="jumpRoute(menu.routerName)"><span>{{menu.name}}</span></a>
                                </li>
                                <li v-else class="dropdown nav-li-hide" 
                                :class="{'menu-active':routerName == menu.routerName}" 
                                @mouseover="showDropMenu(menu.routerName)" 
                                @mouseout="hideDropMenu(menu.routerName)"
                                >
                                    <div class="dropdown-toggle" data-hover="dropdown" data-toggle="dropdown">{{menu.name}}<b class="caret"></b>
                                    </div>
                                    <ul class="dropdown-menu more" v-show="checkMenuShow(menu.routerName)">
                                        <template v-for="(submenu, subkey) in menu.children">
                                            <li class="dropdown menu-li" @click="jumpRoute(submenu.menuList[0].name)">{{submenu.title}}</li>
                                        </template>
                                    </ul>
                                </li>
                            </template>
                        </template>
                    </ul>
                </div>
                <div class="header-avator-con">
                    <ul class="nav">
                        <li class="dropdown" :class="{'menu-active':routerName=='company'}" v-if="handleShowOrNot('company')">
                            <a @click="jumpRoute('company')"><Icon type="ios-settings" /><span>系统设置</span></a>
                        </li>
                        <li class="dropdown">
                            <Poptip title="" content="content" placement="bottom" trigger="hover" width="400">
                                <a><Icon type="md-search"></Icon>搜索</a>
                                <div slot="content" class="poptip-content" style="padding: 20px">
                                    <Select v-model="keywordType" style="width: 80px;" class="select">
                                        <Option value="Company">企业</Option>
                                        <Option value="Item">项目</Option>
                                        <Option value="Carrier">载体</Option>
                                        <!--<Option value="Companies">单位</Option>-->
                                    </Select>
                                    <Input v-model="keyword" class="inp" :placeholder="keywordType==='Company' ? '企业名称' : '名称 编号 电话'" style="width:180px;" @keyup.enter.native="keywordSearch()"></Input>
                                    <Button type="success" class="search" @click="keywordSearch">搜索</Button>
                                </div>
                            </Poptip>
                        </li>
                        <li class="dropdown" v-if="handleShowOrNot('usercenter')">
                            <a @click="jumpRoute('usercenter')" :class="{'menu-active':routerName=='usercenter'}"><Icon type="md-person"></Icon> {{userinfo.username ? userinfo.username : '未完善姓名'}}</a>
                        </li>
                        <li class="dropdown" @mouseover="messagesShow" @mouseout="messagesHide">
                            <a href="#" style="position: relative;"><Icon type="md-mail"></Icon> <span>消息</span><span class="count" style="right:0px" v-if="msgCount > 0">{{msgCount}}</span></a>
                            <ul class="dropdown-menu notifications-list messages-list" ref="massgesWrapper">
                                <li class="item first-item" v-for="item in messages">
                                    <a @click="readMsg(item)">
                                        <img src="//img.xuannaer.com/static/MmsIndex/img/icon-1.jpg" alt="">
                                        <div class="content">
                                            <span class="content-headline wuweidu" :title="item.title">{{item.title}} </span>
                                            <span class="content-text" :title="item.content">{{item.content}}</span>
                                            <span class="time"><Icon v-if="item.dateline" type="ios-time-outline"></Icon>{{item.dateline}}</span>
                                        </div>
                                    </a>
                                </li>
                                <li class="item first-item" v-if="msgCount == 0">
                                    <p @click="jumpRoute('usercenter-messages')" style="width: 100%;text-align: center;line-height: 80px; ">暂无未读消息</p>
                                </li>
                                <li class="item-footer">
                                    <a @click="jumpRoute('usercenter-messages')">查看全部消息</a>
                                </li>
                            </ul>
                        </li>
                        <li class="dropdown ">
                            <a href="#" @click="userLogout"><Icon type="md-power" size="10"></Icon><span>退出</span></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="sidebar-menu-con" :style="{width: shrink?'60px':'220px', overflow: shrink ? 'visible' : 'auto'}">
            <ShrinkableMenu
                :shrink="shrink"
                :theme="menuTheme"
                :menu-list="menuList">
            </ShrinkableMenu>
        </div>
        <div class="single-page-con" id="_content_wrapper" ref="pagebody" :class="{'isshrink' : shrink}">
            <div class="single-page">
                <router-view/>
            </div>
            <common-footer></common-footer>
        </div>
        <!--TODO 如果以后底部出问题记得改回来-->
        <!--<common-footer :style="{paddingLeft: shrink?'60px':'220px'}"></common-footer>-->
    </div>
</template>

<script>
import TopNotification from '@/components/topNotification/topNotification.vue';
import ShrinkableMenu from './business/ShrinkableMenu.vue';
import menuArray from '@/staticData/menuArray';
import CommonFooter from './business/CommonFooter.vue';
import $api from "@/service/index";
import utils from "@/utils";
import Cookie from 'js-cookie';
import routeAuth from "@/staticData/routeAuthEnum";
import MessageType from '@/staticData/messageType';
    
    export default {
        components: {
            ShrinkableMenu,
            CommonFooter,
            TopNotification
        },
        data () {
            return {
                //当前路由名
                routerName:'index',
                subName:'',
                location:false,
                username:'未完善姓名',
                menuList: [],
                menuArray: menuArray,
                shrink: false,
                menuTheme:'dark',
                keywordType: 'Company',
                keyword: '',
                hasWechat : true,
                showMenu : {
                    'item' : false,
                    'carrier' : false,
                }
            }
        },
        watch: {
            $route: {
                handler: function(val, oldVal){
                    this.initMenu();
                },
                deep: true
            }
        },
        computed: {
            //处于加入单位的哪一步
            companyStep(){
                return this.$store.state.companyStep;
            },
            //右上角单位名
            company(){
                if(this.$store.state.companyStep.step == 6){
                    return this.$store.state.commonData.userinfo.company_name;
                }else{
                    return '未加入单位';
                }
            },
            //消息的红色未读
            msgCount(){
                return this.$store.state.commonData.noticeCount;
            },
            //消息内容
            messages(){
                return this.$store.state.commonData.noticeinfo;
            },
            //用户信息
            userinfo(){
                return this.$store.state.commonData.userinfo;
            },
        },
        methods: {
            //判断浏览器版本并作出提示
            getBrowser(){
                let version = utils.getBrowserVersion();
                let _self = this;
                if(version === "IE6" ||version === "IE7" || version === "IE8" || version === "IE9" || version === "IE10" || version === "IE11" || version === "IE"){
                    this.$nextTick(()=>{
                        _self.$refs.topNotification.show();
                    });
                }
            },
            //显示信息
            messagesShow(){
                this.$refs.massgesWrapper.style.display = "block";
            },
            //隐藏信息
            messagesHide(){
                this.$refs.massgesWrapper.style.display = "none";
            },
            //菜单收缩控制
            toggleClick () {
                this.shrink = !this.shrink;
            },
            //头部搜索
            keywordSearch(){
                switch(this.keywordType){
                    case "Item":
                        //项目搜索
                        this.$router.push({ path: '/index/project-search/project-search-list', query: { is: '2',pg: '1',ps: '10',ct: '0',sd: '',st:'',kw: `${this.keyword}`,pc:false}});
                        break;
                    case "Carrier":
                        //载体搜索
                        this.$router.push({ path: '/index/carrier-search/carrier-search-list', query: { is: '2',pa: '1',ps: '10',ct: '0',si: '',st:'',kw: `${this.keyword}`} });
                        break;
                    case "Company":
                        //企业搜索
                        this.$router.push({ path: '/index/company-search/company-search-list', query: { tab: '1',page: '1',pageSize: '10',name: `${this.keyword}`} });
                        break;
                    default:
                        break;
                }
                return false;
            },
            //单位和用户中心跳转
            jumpRoute (routeName){
                this.$router.push({
                    name: routeName
                });
            },
            //退出
            userLogout(){
                $api.userLogout().then(()=>{
                    utils.setLoginStatus('2');
                    utils.clearUserCookie();
                    this.$router.push({
                        path: '/login'
                    });
                });
            },
            /**
             * 菜单权限 控制菜单是否显示
             * @param {string} routeName 路由名
             * @return {boolean}
             */
            handleShowOrNot(routeName){
                let authRes = false;
                if(routeAuth[routeName] && routeAuth[routeName].auth){
                    let authName = routeAuth[routeName].auth;
                    let authType = routeAuth[routeName].type;
                    authRes = utils.judgeAuth(authName,authType);
                }
                return authRes;
            },
            //左侧菜单 过滤掉没有权限的菜单
            filterMenuByAuth(leftMenuList){
                let menuList = JSON.parse(JSON.stringify(leftMenuList));
                if(menuList){
                    for(let k=0; k< menuList.length; k++){
                        if(menuList[k].menuList){
                            for(let j=0; j<menuList[k].menuList.length; j++){
                                let hasAuth = this.handleShowOrNot(menuList[k].menuList[j].name);
                                if(hasAuth === false){
                                    menuList[k].menuList.splice(j, 1);
                                    j--;
                                }
                            }
                            if(menuList[k].menuList.length == 0){
                                menuList.splice(k, 1);
                                k--;
                            }
                        }
                    }
                }                
                return menuList;
            },
            /**
             * 阅读消息
             * @param {object} item 一条消息里的数据
             */
            readMsg(item){
                let data = { ids: [item.id] };
                switch(item.msgType){
                    //系统消息
                    case '1':
                        if(item.type !== "1"){
                            this.jumpRoute('usercenter-messages')
                            break;
                        }
                        $api.readSystemMsg(data).then((msg)=>{
                            let showMsg = MessageType.systemMsgJump(this.$router, item);
                        });
                        break;
                    //推送消息
                    case '2':
                        $api.readPushsMsg(data).then((msg)=>{
                            MessageType.pushMsgJump(this.$router, item);
                        });
                        break;
                }
            },
            checkWechat() {
                let _self = this;
                $api.userinfo(Cookie.get("uid")).then(data => {
                    if(data.unionid == 0 || data.unionid == "" || data.unionid === undefined ){
                        _self.hasWechat = false;
                    } else {
                        _self.hasWechat = true;
                    }
                });
            },
            /**
             * 禁用拖动事件[全局解决上传空间弹窗弹不出来的bug]
             */
            banDropEvent(){
                this.$nextTick(()=>{
                    document.addEventListener("drop",(e)=>{
                        e.preventDefault();
                        return false;
                    });
                    document.addEventListener("dragenter",(e)=>{
                        e.preventDefault();
                        return false;
                    });
                    document.addEventListener("dragover",(e)=>{
                        e.preventDefault();
                        return false;
                    });
                    document.addEventListener("dragend",(e)=>{
                        e.preventDefault();
                        return false;
                    });
                });
            },
            showDropMenu(name){
                this.showMenu[name] = true;
            },
            hideDropMenu(name){
                this.showMenu[name] = false;
            },
            checkMenuShow(name) {
                return this.showMenu[name];
            },

            transfor(name) {
                switch(name) {
                    case 'land-item-edit':
                        return 'land-item-add';
                    case 'land-carrier-edit':
                        return 'land-carrier-add';
                    case 'factory-item-edit':
                        return 'factory-item-add';
                    case 'factory-carrier-edit':
                        return 'factory-carrier-add';
                    case 'officebuilding-item-edit':
                        return 'officebuilding-item-add';
                    case 'officebuilding-carrier-edit':
                        return 'officebuilding-carrier-add';
                    case 'warehouse-item-edit':
                        return 'warehouse-item-add';
                    case 'warehouse-carrier-edit':
                        return 'warehouse-carrier-add';
                    default :
                        return name;
                }
            },
            initMenu(){
                let routerName = this.$route.path.split("/")[1];
                if (routerName == 'land' || routerName == 'factory' || routerName == 'warehouse' || routerName == 'officebuilding') {
                    let subRouter = this.$route.path.split("/")[2];
                    if (subRouter) {
                        this.routerName = subRouter.split('-')[1];
                        this.subName = subRouter;
                    }
                } else {
                    this.routerName = routerName;
                }
                for(let i in this.menuArray){
                    if (this.menuArray[i].type == 'simple') {
                        if(this.menuArray[i].routerName == this.routerName){
                            this.menuList = this.filterMenuByAuth(this.menuArray[i].modular);
                            break;
                        }
                    } else {
                        for (let j in this.menuArray[i].children) {
                            for (var k = 0; k < this.menuArray[i].children[j].menuList.length; k++) {
                                if(this.menuArray[i].children[j].menuList[k].name == this.transfor(this.subName)){
                                    this.menuList = this.filterMenuByAuth([this.menuArray[i].children[j]]);
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        },
        mounted () {
            this.initMenu();
            this.checkWechat();
            this.banDropEvent();
        },
        created () {
            //IE浏览器提示
            this.getBrowser();
            this.$Notice.config({
                top: 65,
            });
            //定时器刷新登录状态
            utils.setLoginStatus('1',()=>{
                if(!(!Cookie.get('uid') || !Cookie.get('token') || !Cookie.get("theOne"))){
                    $api.getCompanyBusinessTypes().then(()=>{})
                }
            });
        }
    };
</script>

<style lang="less" scoped>
    @import "./main.less";
    
    
</style>



// WEBPACK FOOTER //
// src/pages/layout/Layout.vue